






















import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app';
import Vue2Filters from 'vue2-filters'
import i18n from '@/i18n'

Vue.use(Vue2Filters)

@Component({
    name: 'headline'
})

export default class Headline extends Vue {
    private fontSize = '20px'

    @Prop() private titleKey!:string
    get price() {
        if (AppModule.session.products !== undefined){
            for (let i = 0; i < AppModule.session.products.length; i++){
                if (AppModule.session.products[i].itemId === AppModule.productID){
                    let price = AppModule.session.products[i].price
                    if (price !== undefined){
                        return price.price
                    }
                }
            }
        }
        return ""
    }

    @Watch('price')
    onPriceChanged(price: number){
        this.fontSize = '26px'
        setTimeout(() => this.fontSize = '20px', 1000);
    }


    get currencySymbol() {
        if(AppModule.session.products && AppModule.session.products.length > 0 && AppModule.session.products[0].price) {
            if(AppModule.session.products[0].price.currency == "EUR") return "€"
            if(AppModule.session.products[0].price.currency == "USD") return "$"
            if(AppModule.session.products[0].price.currency == "GBP") return "£"
            if(AppModule.session.products[0].price.currency == "CHF") return "SFr. "
            return AppModule.session.products[0].price.currency
        }
        return ""
    }
    
    get currencyFilterOptions() {
        if(AppModule.session.products && AppModule.session.products.length > 0 && AppModule.session.products[0].price) {
            if(AppModule.session.products[0].price.currency == "EUR") return {thousandsSeparator: '.',decimalSeparator: ',', symbolOnLeft: false, spaceBetweenAmountAndSymbol: true}
            if(AppModule.session.products[0].price.currency == "USD") return {}
        }
        return {}
    }

    get deliveryCountry() {
        if (AppModule.session.deliveryCountry) {
            return i18n.t(AppModule.session.deliveryCountry.toLowerCase())
        }
        return ""
    }
    
    showShippingCost() {
        AppModule.SetShowShippingOverlay(true)
    }
}
